import React from 'react'

export default () => (

<svg width="12" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M10.85 5.757a.35.35 0 01-.35-.35v-1.05H8.05a.35.35 0 01-.35-.35v-2.45H1.75c-.58 0-1.05.47-1.05 1.05v10.5c0 .58.47 1.05 1.05 1.05h7.7c.58 0 1.05-.47 1.05-1.05v-1.4a.35.35 0 11.7 0v1.4a1.75 1.75 0 01-1.75 1.75h-7.7A1.75 1.75 0 010 13.106v-10.5C0 1.64.783.857 1.75.857h6.28a.342.342 0 01.267.102l2.8 2.8a.342.342 0 01.102.267v1.38a.35.35 0 01-.35.35zm-.845 2.8H4.54a.35.35 0 110-.7h5.465L8.502 6.354a.35.35 0 01.495-.495l2.1 2.1a.35.35 0 010 .495l-2.1 2.1a.35.35 0 01-.495-.495l1.503-1.502zM8.4 2.052v1.605h1.605L8.4 2.052z" fill="#000" fillRule="nonzero"/></svg>
  )

